<template>
  <b-modal hide-footer centered v-model="visible">
    <template #modal-title> Change Status </template>
    <b-form-group
      label-for="status"
      class="w-100 pt-1"
      label="Change the current status"
    >
      <b-button-group class="mt-1">
        <button
        class="btn text-white mx-25 hover-warning"
          :class="status == 'PENDING' ? 'bg-warning' : ' '"
          @click="status = 'PENDING'"
          style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
        >
          Pending
        </button>
        <button
        class="btn text-white mx-25 hover-success"
          :class="status == 'ACCEPTED' ? 'bg-success' : '  '"
          @click="status = 'ACCEPTED'"
        >
          Accepted
        </button>
        <button
        class="btn text-white mx-25 hover-danger"
          :class="status == 'REJECTED' ? 'bg-danger' : '  '"
          @click="status = 'REJECTED'"
          style="
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          "
        >
          Rejected
        </button>
      </b-button-group>
    </b-form-group>
    <div class="w-100 d-flex align-items-center justify-content-end">
      <b-button
        @click="changeStatus"
        class="  gradient-btn"
        :disabled="status == currentData.status"
      >
        {{ status == currentData.status ? "Current status" : "Change status" }}
      </b-button>
    </div>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BButton, BButtonGroup } from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BButtonGroup,
    Loader,
  },
  props: {
    currentData: {
      status: Object,
      default: () => {},
    },
    showChangeStatus: {
      status: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: "",
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.showChangeStatus;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    currentData(val) {
      this.status = val.status;
    },
  },
  created() {
    this.status = this.currentData.status;
  },
  methods: {
    async changeStatus() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          "/panel/protests/" + this.currentData.id + "?_method=put",
          {
            competition_id: this.currentData.competition_id,
            content: this.currentData.content,
            subject: this.currentData.subject,
            status: this.status,
          }
        );
        this.$emit("updateProtests");
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style   scoped>
.btn{
 background-color: #252531 ;
    border: 1px solid #ffffff0d  ;
}

 
</style>> 
